import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { parse } from "lib/locale";
import { ListEmailTemplate } from "models/list-email-template";
import { Fragment, FunctionComponent, useState } from "react";
import { useLocale } from "stores/hooks/locale";
import EmailTemplateModal from "./email-template-modal";
import { List } from "models/list";
import { useTranslate } from "stores/hooks/translation";

interface EmailTemplatesTableProps {
  list: List;
  listEmailTemplates: ListEmailTemplate[];
  onUpdate: () => Promise<void>;
}

const EmailTemplatesTable: FunctionComponent<EmailTemplatesTableProps> = ({
  list,
  onUpdate,
  listEmailTemplates,
}) => {
  const translate = useTranslate();
  const locale = useLocale();
  const [template, toggleTemplate] = useState<ListEmailTemplate | undefined>(
    undefined,
  );

  const columns: ColumnInterface[] = [
    {
      key: "type",
      header: "Käyttötarkoitus",
      render: (emailTemplate: ListEmailTemplate) =>
        translate(`email_template_type_${emailTemplate.type}`),
      width: 200,
    },
    {
      key: "subject",
      header: "Otsikko",
      render: (emailTemplate: ListEmailTemplate) =>
        parse(emailTemplate.subject, locale),
    },
  ];

  return (
    <Fragment>
      <Table
        name={`list-${list.uuid}-email-templates`}
        data={listEmailTemplates}
        columns={columns}
        editers={[{ onClick: async (template) => toggleTemplate(template) }]}
      />
      {template && (
        <EmailTemplateModal
          list={list}
          template={template}
          onUpdate={onUpdate}
          onClose={async () => toggleTemplate(undefined)}
        />
      )}
    </Fragment>
  );
};

export default EmailTemplatesTable;
